import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { EnvErrorScreen } from "./components/EnvErrorScreen";

// Global error handling
if (typeof window !== 'undefined') {
  window.addEventListener('error', (event) => {
    console.error('[Global Error]:', event.error || event.message);
  });

  window.addEventListener('unhandledrejection', (event) => {
    console.error('[Unhandled Rejection]:', event.reason);
  });
}

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error('Root element not found');
}

const root = createRoot(rootElement);

// Validate environment and render app
(async () => {
  let envError: Error | null = null;
  
  try {
    // Import validateEnv - it validates on module load
    await import("./lib/validateEnv");
  } catch (error) {
    envError = error instanceof Error ? error : new Error(String(error));
    console.error('[ENV Validation]:', envError);
  }

  // Render error screen if env validation failed, otherwise render app
  if (envError) {
    root.render(<EnvErrorScreen error={envError} />);
  } else {
    root.render(<App />);
  }
})();

